// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniCartLineStyles } from "@guestsupply/App/Components/MiniCart/MiniCartLine";
import { color, ellipsis, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

miniCartLineStyles.cartLine = {
    css: css`
        display: flex;
        position: relative;
        padding: 12px 0;
        justify-content: flex-start;
        &:first-child {
            padding-top: 16px;
        }
    `,
};
miniCartLineStyles.imageWrapper = {
    css: css`
        width: 60px;
        height: 60px;
        overflow: hidden;
        margin-right: 12px;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
    `,
};
miniCartLineStyles.cartLineImage = {
    css: css`
        height: 60px;
        img {
            height: auto;
            width: 100%;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};
miniCartLineStyles.detailsWrapper = {
    css: css`
        width: 100%;
    `,
};
miniCartLineStyles.imageAndDescriptionWrapper = {
    css: css`
        display: flex;
        max-width: 247px;
        width: 100%;
    `,
};
miniCartLineStyles.contentWrapper = {
    css: css`
        display: flex;
        gap: 18px;
        width: 100%;
        align-items: flex-start;
    `,
};
miniCartLineStyles.rightSideWrapper = {
    css: css`
        display: flex;
        width: 100%;
    `,
};
miniCartLineStyles.lineDescription = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
        weight: "bold",
        css: css`
            ${ellipsis(4)}
            letter-spacing: 0;
            text-decoration: none;
            &&&& {
                color: ${color("text.main")};
                &:hover {
                    text-decoration: none;
                    color: ${color("primary.main")};
                }
            }
        `,
    },
    css: css`
        width: 175px;
        align-items: baseline;
    `,
};
miniCartLineStyles.qtyWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 50px;
    `,
};
miniCartLineStyles.cartLineQuantityStyles = {
    qtyFieldStyles: {
        wrapper: {
            css: css`
                align-items: center;
            `,
        },
        editableQuantityTextField: {
            cssOverrides: {
                inputSelect: css`
                    width: 50px;
                    max-height: 28px;
                    min-height: 28px;
                    font-weight: 400;
                    line-height: 16px;
                    text-align: center;
                    &,
                    &:focus {
                        padding: 0;
                    }
                `,
            },
        },
    },
};
miniCartLineStyles.extendedPriceWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        max-width: 97px;
        min-width: 97px;
    `,
};
miniCartLineStyles.basicProductPriceStyles = {
    priceWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    price: {
        priceText: {
            weight: "bold",
            size: 13,
            css: css`
                line-height: 14px;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 12,
                weight: 400,
                css: css`
                    white-space: nowrap;
                    letter-spacing: 0;
                    line-height: 13px;
                    margin: 0;
                `,
            },
        },
    },
};
miniCartLineStyles.totalPriceWrapper = {
    css: css`
        flex-grow: 1;
        width: 91px;
        max-width: 91px;
        line-height: 15px;
    `,
};
miniCartLineStyles.removeCartLineLink = {
    css: css`
        margin-left: auto;
        height: 16px;
        ${IconWrapper}, svg {
            color: ${color("primary")};
            width: 10px;
            height: 16px;
            line-height: 17px;
            text-align: center;
            &:hover {
                opacity: 0.5;
            }
        }
    `,
};
miniCartLineStyles.cartLineTotal = {
    size: 13,
    weight: "bold",
    css: css`
        line-height: 14px;
        white-space: nowrap;
    `,
};
miniCartLineStyles.errorMessagesWrapper = {
    css: css`
        width: 100%;
        margin-top: 10px;
        & > div:not(:last-child) {
            margin-bottom: 12px;
        }
    `,
};
miniCartLineStyles.leftSideWrapper = {
    css: css`
        max-width: 293px;
        width: 100%;
    `,
};
miniCartLineStyles.seperator = {
    css: css`
        padding: 0 17px;
        border-bottom: 1px solid ${color("common.border")};
        &:last-child {
            border-bottom: none;
        }
    `,
};
miniCartLineStyles.notify = {
    css: css`
        margin-bottom: 0;
    `,
};
